export const INGEST_RUN_STATUSES = [
  { id: 'ok', name: 'ok' },
  { id: 'error', name: 'error' },
  { id: 'running', name: 'running' },
  { id: 'stuck', name: 'stuck' },
];

export const INGEST_RUN_STATUS_COLORS = {
  ok: 'success',
  error: 'error',
  running: 'default',
  stuck: 'warning',
};

export const INGEST_RUN_ERROR_PREVIEW_LENGTH = 80;
export const INGEST_RUN_DEFAULT_DAYS = 7;

export const INGEST_RUN_STUCK_MESSAGE = 'The run did not finish and no error was recorded; the process died mid-write.';
export const INGEST_RUN_NO_ERROR_TEXT = 'No error text recorded.';
